import {
    Sheet,
    SheetHeader,
    SheetTitle,
    SheetDescription,
    SheetClose,
    SheetContentCus
} from '@/components/common/Sheet';
import { ekDomain, kickboardClassName, ROUTES } from '@/configs/constants';
import * as VisuallyHidden from '@radix-ui/react-visually-hidden';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import MenuEU from './_components/MenuEU';
import { isPathEk } from '@/utils/routes';
import { useTranslation } from 'react-i18next';
import { useStore } from '@/hooks/useStore';
import { Portal as RadixPortal } from '@radix-ui/react-portal';
import classNames from 'classnames';
import './style.scss';

interface WrapperSheetCloseProps {
    useSheetClose?: boolean
}

export const WrapperSheetClose = React.forwardRef<
    HTMLDivElement,
    React.HTMLAttributes<HTMLDivElement> & WrapperSheetCloseProps
>(({ children, useSheetClose, ...props }, ref) => (
    <div ref={ref} {...props}>
        {
            !useSheetClose ?
                (
                    <>{children}</>
                ) :
                (
                    <SheetClose asChild>{children}</SheetClose>
                )
        }
    </div>
));
WrapperSheetClose.displayName = 'WrapperSheetClose';

export default function SheetMenuEU() {
    // hook
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const isEk = isPathEk(pathname);

    // store
    const {
        authStore: { tokenGas, tokenEk, logout },
        modalStore: { showAlertModal, hideModal }
    } = useStore();

    // state
    const [open, setOpen] = useState<boolean>(false);

    // life cycle
    useEffect(() => {
        if (open) {
            setOpen(false);
        }
    }, [pathname]);

    const closeNode = () => (
        <div
            onClick={() => {
                setOpen(!open);
            }}
            className={classNames(
                'hum-btn bg-primaryWeb point-940:hidden w-[min(60px,15vw)] z-[65] fixed top-0 right-0 flex items-center justify-center',
                open && 'open',
                isEk ? `${kickboardClassName}` : ''
            )}
        >
            <div
                className='button relative inline-block'
            >
            </div>
        </div>
    );

    const handleLogout = () => {
        const idModal = 'confirm-logout-modal';
        showAlertModal({
            id: idModal,
            size: 'sm',
            content: t('messages.confirm_logout'),
            isConfirmModal: true,
            saveButton: t('button.sign_out'),
            onSave: () => {
                hideModal(idModal);
                logout();
            }
        });
    };

    return (
        <>
            <Sheet
                open={open}
                onOpenChange={() => {
                    setOpen(!open);
                }}
            >
                <SheetContentCus
                    sheetOverlayClassName='bg-transparent'
                    className='w-[min(390px,100vw)] pt-[min(80px,18vw)] px-[min(40px,5vw)] pb-[min(50px,5vw)] h-[100dvh] overflow-y-auto scrollbar-width-2 flex flex-col bg-black-3'
                    side='menuEu'
                    closeNode={(
                        closeNode()
                    )}
                >
                    <SheetHeader className='hidden'>
                        <SheetTitle>
                            <VisuallyHidden.Root>
                                {/* Sheet Menu */}
                            </VisuallyHidden.Root>
                        </SheetTitle>
                        <SheetDescription>
                            <VisuallyHidden.Root>
                                {/* Description goes here */}
                            </VisuallyHidden.Root>
                        </SheetDescription>
                    </SheetHeader>
                    <div className='text-white header-menu'>
                        <MenuEU useSheetClose isMenuSheet={true} />
                        {
                            ((isEk && !tokenEk) || (!isEk && !tokenGas)) && (
                                <div className=' grid gap-[min(20px,5vw)] mt-[min(40px,10vw)]'>
                                    <div className='w-full max-w-[320px] round-button'>
                                        <a href={isEk ? `/${ekDomain}${ROUTES.signup.href}` : ROUTES.signup.href} className='relative'>
                                            <span>新規会員登録</span>
                                        </a>
                                    </div>
                                    <div className='w-full max-w-[320px] round-button'>
                                        <a href={isEk ? `/${ekDomain}${ROUTES.signin.href}` : ROUTES.signin.href} className='relative'><span>会員ログイン</span></a>
                                    </div>
                                </div>
                            )
                        }
                        {
                            ((isEk && tokenEk) || (!isEk && tokenGas)) && (
                                <div className=' grid gap-[min(20px,5vw)] mt-[min(40px,10vw)]'>
                                    <div className='w-full max-w-[320px] round-button'>
                                        <a href={isEk ? `/${ekDomain}${ROUTES.myAccount.href}` : ROUTES.myAccount.href} className='relative'>
                                            <span>{t('words_title.my_page')}</span>
                                        </a>
                                    </div>
                                    <div className='w-full max-w-[320px] round-button'>
                                        <div
                                            onClick={() => {
                                                handleLogout();
                                                document.body.style.pointerEvents = 'auto';
                                            }}
                                            className='relative'
                                        >
                                            <span>{t('words_title.sign_out')}</span>
                                        </div>
                                    </div>
                                </div>
                            )
                        }

                    </div>
                </SheetContentCus>
            </Sheet>
            <RadixPortal>
                {closeNode()}
            </RadixPortal>
        </>

    );
}
